const ENVIRONMENT = import.meta.env.PROD ? 'production' : 'development';

if (!['development', 'production'].includes(ENVIRONMENT)) {
  console.warn(`Invalid environment "${ENVIRONMENT}", defaulting to production for safety`);
}

const API_BASE_URLS = {
  development: 'http://localhost:8787',
  production: 'https://examencap.es/api'
};

export const API_URL = API_BASE_URLS[ENVIRONMENT] || API_BASE_URLS.production;

export const getApiUrl = (endpoint) => `${API_URL}${endpoint}`;

export const API_ENDPOINTS = {
  // Auth endpoints
  validateToken: '/token/validate',
  logout: '/logout',
  
  // School endpoints
  schoolLogin: '/school/login',
  schoolVerify: '/school/verify',
  schoolRegister: '/school/register',
  schoolTokenCreate: '/school/token/create',
  schoolTokensPurchase: '/school/tokens/purchase',
  
  // Direct student endpoints
  directStudentRegister: '/direct-student/register',
  
  // Trial endpoints
  trialCheck: '/trial/check',
  
  // Health check endpoints
  health: '/health',
  healthDb: '/health/db',

  // Questions endpoints
  questions: {
    getAll: '/questions/getAll',
    getByType: '/questions/getByType'
  },

  // Admin endpoints
  admin: {
    updateQuestions: '/admin/updateQuestions'
  }
};